<script setup>
import { formattedPrices } from '@/core/utils/formatters'
import { useRouter } from 'vue-router';
import { onMounted, onUnmounted, ref } from 'vue'

const router = useRouter()
const account = ref(false)
const isLoggin = ref(true)
const userData = ref({
  names: 'Jesus Luis Alberto',
})

const productsList = ref([
  {
    id: 1,
    image: 'images/shop/trendy-shirt.jpg',
    url: '/',
    name: 'T-shirt',
    size: 'M',
    gender: '',
    price: 320.0,
    qty: 2,
  },
  {
    id: 2,
    image: 'images/shop/luxurious-bag2.jpg',
    url: '/',
    name: 'Bag',
    size: '',
    gender: '',
    price: 50.0,
    qty: 5,
  },
  {
    id: 3,
    image: 'images/shop/apple-smart-watch.jpg',
    url: '/',
    name: 'Bag',
    size: '',
    gender: 'H',
    price: 800.0,
    qty: 1,
  },
])

onMounted(() => {
  window.addEventListener('click', close)
})

onUnmounted(() => {
  window.removeEventListener('click', close)
})

const close = (e) => {
  if (!e.target.closest('#buttonProfile')) {
    account.value = false
  }
}

const resolveTotal = () => {
  return formattedPrices(
    productsList.value.reduce((sum, { price, qty }) => sum + price * qty, 0)
  )
}

const logout = () => {
  isLoggin.value = false
}

const toUrl = val => {
  const url = `/${val}`
  router.replace(url)
  account.value = false
}
</script>
<template>
  <li id="buttonProfile" class="dropdown inline-block relative ps-0.5">
    <button
      @click.prevent="account = !account"
      class="items-center"
      type="button"
    >
      <span
        class="size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full border border-red-cc bg-red-cc text-white"
        ><img
          src="../../../assets/images/client/16.jpg"
          class="rounded-full"
          alt=""
      /></span>
    </button>
    <!-- Dropdown menu -->
    <div
      class="dropdown-menu absolute end-0 m-0 mt-4 z-10 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-800"
      :class="
        account === false ? 'hidden' : isLoggin === true ? 'w-64' : 'w-52'
      "
    >
      <ul v-if="isLoggin" class="py-2 text-start">
        <li class="ms-0">
          <p class="text-slate-400 pt-2 px-4">
            {{ `Bienvenido ${userData.names}!` }}
          </p>
        </li>
        <li class="ms-0">
          <p class="flex items-center font-medium py-2 px-4">
            <i data-feather="shopping-cart" class="h-4 w-4 me-2"></i>
            Balance:
            <span class="text-red-cc ms-2">{{ resolveTotal() }}</span>
          </p>
        </li>
        <li class="ms-0">
          <button
            @click="toUrl('profile')"
            class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-cc dark:hover:text-white"
            ><i data-feather="user" class="h-4 w-4 me-2"></i>Perfil</button
          >
        </li>
        <li class="border-t border-gray-100 dark:border-gray-800 my-2"></li>
        <li class="ms-0">
          <span @click="logout" class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-cc dark:hover:text-white cursor-pointer">
            <i data-feather="log-out" class="h-4 w-4 me-2"></i>Logout
          </span>
        </li>
      </ul>
      <ul v-else class="py-2 text-start">
        <li class="ms-0">
          <router-link
            to="user-account"
            class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-cc dark:hover:text-white"
            >Iniciar sesión</router-link
          >
        </li>
        <li class="ms-0">
          <router-link
            to="user-account"
            class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-red-cc dark:hover:text-white"
            >Registrarse</router-link
          >
        </li>
      </ul>
    </div>
  </li>
</template>
<style lang=""></style>
